import { render, staticRenderFns } from "./NotificationComposeConfirm.vue?vue&type=template&id=1e23ffe0&"
import script from "./NotificationComposeConfirm.vue?vue&type=script&lang=js&"
export * from "./NotificationComposeConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports